<template>
    <a v-if="isInternalLink(path)" :href="path" :target="[brankFlag ? '_blank' : '_self']">
    <div class="contents-title-btn">
      <div class="page-number">
        <h1 class="number-txt" v-html="number"></h1>
      </div>
      <img :class="{showSubImg: isShowSubImg, 'sub-img': true}" :src="subImgSrc" alt="" />
      <div class="contents-title-txt" v-html="title"></div>
      <img v-if="iconImg" :src="iconImg" :class="icon" alt="" />
    </div>
  </a>

  <a v-else @click="transitionPage(path)">
    <div class="contents-title-btn">
      <div class="page-number">
        <h1 class="number-txt" v-html="number"></h1>
      </div>
      <img :class="{showSubImg: isShowSubImg, 'sub-img': true}" :src="subImgSrc" alt="" />
      <div class="contents-title-txt" v-html="title"></div>
      <img v-if="iconImg" :src="iconImg" :class="icon" alt="" />
    </div>
  </a>
</template>

<script>
import { computed } from "vue";
import { isInternalLink } from "@/assets/scripts/utils/url";
import pageTransition from "@/composables/pageTransition";
import { useStore } from "vuex";

export default {
  name: "ContentsTitleButton",
  props: {
    number: String,
    subImg: String,
    title: String,
    icon: String,
    path: { type: String, default: "" },
    brankFlag: { type: Boolean, default: false },
  },
  setup(props) {
    const { transitionPage } = pageTransition();
    const store = useStore();

    const clickLink = () => {
      let target = "_self"
      if(props.brankFlag){
        target = "tab_" + Math.random().toString(32).substring(2, 9);
      }
      window.open(props.path, target);
    }

    let iconImg = computed(() => {
      if (store.state.isDarkMode == false) {
        //テキスト内イメージモード変更
        for (let i = 0; i < store.state.textImg.length; i++) {
          let changeObjs = document.getElementsByClassName(store.state.textImg[i])
          for(let j = 0;j < changeObjs.length; j++){
            // console.log(1111);
            changeObjs[j].className = store.state.textImg[i];
          }
        }
        //アイコン分岐
        if (props.icon === "icon-blank") {
          return null;
        } else if (props.icon === "icon-movie") {
          //動画
          return store.state.iconImg.lightMovieImg;
        } else if (props.icon === "icon-sound") {
          //音声
          return store.state.iconImg.lightSoundImg;
        } else if (props.icon === "icon-simulation") {
          //シミュレーション
          return store.state.iconImg.lightSimulationImg;
        } else if (props.icon === "icon-work") {
          //ワークシート
          return store.state.iconImg.lightWorkImg;
        } else if (props.icon === "icon-document") {
          //資料
          return store.state.iconImg.lightDocumentImg;
        } else if (props.icon === "icon-practice") {
          //練習
          return store.state.iconImg.lightPracticeImg;
        } else if (props.icon === "icon-program") {
          //プログラミング
          return store.state.iconImg.lightProgramImg;
        } else if (props.icon === "icon-web") {
          //WEBページ
          return store.state.iconImg.lightWebImg;
        } else if (props.icon === "icon-link") {
          //他教科リンク
          return store.state.iconImg.lightLinkImg;
        } else if (props.icon === "icon-tablet") {
          //iPadとタッチペン
          return store.state.iconImg.lightTabletImg;
        } else if (props.icon === "icon-star") {
          //星型
          return store.state.iconImg.lightStarImg;
        } else if (props.icon === "icon-thinking") {
          //思考ツール
          return store.state.iconImg.lightThinkingImg;
        } else if (props.icon === "icon-vr") {
          //VR
          return store.state.iconImg.lightVrImg;
        } else if (props.icon === "icon-clean") {
          //感染症対策
          return store.state.iconImg.lightCleanImg;
        } else if (props.icon === "icon-conjugation") {
          //情報活用
          return store.state.iconImg.lightConjugationImg;
        } else if (props.icon === "icon-sdgs") {
          //SDGs
          return store.state.iconImg.lightSdgsImg;
        } else if (props.icon === "icon-quiz") {
          //クイズ
          return store.state.iconImg.lightQuizImg;
        } else if (props.icon === "icon-map") {
          //マップ
          return store.state.iconImg.lightMapImg;
        } else {
          return null;
        }
      } else {
        //テキスト内イメージモード変更
        for (let i = 0; i < store.state.textImg.length; i++) {
          let changeObjs = document.getElementsByClassName(store.state.textImg[i])
          for(let j = 0;j < changeObjs.length; j++){
            // console.log(1111);
            changeObjs[j].className = store.state.textImg[i]+" dark-mode";
          }
        }
        //アイコン分岐
        if (props.icon === "icon-blank") {
          return null;
        } else if (props.icon === "icon-movie") {
          //動画
          return store.state.iconImg.darkMovieImg;
        } else if (props.icon === "icon-sound") {
          //音声
          return store.state.iconImg.darkSoundImg;
        } else if (props.icon === "icon-simulation") {
          //シミュレーション
          return store.state.iconImg.darkSimulationImg;
        } else if (props.icon === "icon-work") {
          //ワークシート
          return store.state.iconImg.darkWorkImg
        } else if (props.icon === "icon-document") {
          //資料
          return store.state.iconImg.darkDocumentImg
        } else if (props.icon === "icon-practice") {
          //練習
          return store.state.iconImg.darkPracticeImg
        } else if (props.icon === "icon-program") {
          //プログラミング
          return store.state.iconImg.darkProgramImg
        } else if (props.icon === "icon-web") {
          //WEBページ
          return store.state.iconImg.darkWebImg
        } else if (props.icon === "icon-link") {
          //他教科リンク
          return store.state.iconImg.darkLinkImg
        } else if (props.icon === "icon-tablet") {
          //iPadとタッチペン
          return store.state.iconImg.darkTabletImg
        } else if (props.icon === "icon-star") {
          //星型
          return store.state.iconImg.darkStarImg
        } else if (props.icon === "icon-thinking") {
          //思考ツール
          return store.state.iconImg.darkThinkingImg
        } else if (props.icon === "icon-vr") {
          //VR
          return store.state.iconImg.darkVrImg;
        } else if (props.icon === "icon-clean") {
          //感染症対策
          return store.state.iconImg.darkCleanImg;
        } else if (props.icon === "icon-conjugation") {
          //情報活用
          return store.state.iconImg.darkConjugationImg;
        } else if (props.icon === "icon-sdgs") {
          //SDGs
          return store.state.iconImg.darkSdgsImg;
        } else if (props.icon === "icon-quiz") {
          //クイズ
          return store.state.iconImg.darkQuizImg;
        } else if (props.icon === "icon-map") {
          //マップ
          return store.state.iconImg.darkMapImg;
        } else {
          return null;
        }
      }
    });

    let subImgSrc = computed(() => {
      if(props.subImg === ""){
        return null;
      }else if(props.subImg === "sub01"){
        return require("../assets/images/button_sub_imgs/contents_title_sub01.png");
      }else{
        return null;
      }
    });

    let isShowSubImg = computed(() => {
      return typeof props.subImg === "undefined";
    });
    
    return {
      iconImg,
      subImgSrc,
      transitionPage,
      isInternalLink,
      isShowSubImg,
      clickLink,
    };
  },
};
</script>

<style scoped lang="stylus">
@import '../assets/styles/config.styl';

a
  text-decoration: none
  display: block
  cursor: pointer

.contents-title-btn
  transform translateZ(0)
  position: relative
  width: 57vw
  height: auto
  color: black
  background-color: white
  display: flex
  border-radius: 21px
  font-size: 12px
  filter: drop-shadow(0px 3px 10px rgba(0, 149, 220, 0.5))
  text-align: left
  align-items: center
  transition all .5s ease-out

.dark-mode
  .contents-title-btn
    color var(--dark-white)
    background-color var(--dark-deepblue)
    transition all .5s ease-out
    filter: drop-shadow(0px 3px 10px rgba(0, 149, 220, 0))

// .shadow
//   filter: drop-shadow(0px 3px 10px rgba(0, 149, 220, 0))

.page-number
  transform translateZ(0)
  position: absolute
  width: 120px
  height: 100%
  color: white
  background-color: var(--light-blue)
  display: flex
  align-items: center
  justify-content: center
  border-bottom-left-radius: 10px
  border-top-left-radius: 10px

.dark-mode
  .page-number
    background-color var(--dark-deepblue-light)
    transition all .5s ease-out

.number-txt
  line-height: 20px
  font-size: 18px
  width: 110px
  text-align: center

.contents-title-txt
  width: 90%
  padding-left: 15px
  padding-top: 3%
  padding-bottom: 2.75%
  margin-bottom: 4.5px
  font-size 20px
  font-weight bold

.icon-movie
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-sound
  width: 39.81px
  margin-right: 20px
  margin-left: 2vw

.icon-simulation
  width: 25.01px
  margin-right: 28px
  margin-left: 2vw

.icon-work
  width: 40.74px
  margin-right: 18px
  margin-left: 2vw

.icon-document
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-practice
  width: 40.76px
  margin-right: 18px
  margin-left: 2vw

.icon-program
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-web
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-link
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-tablet
  width: 40.74px
  margin-right: 18px
  margin-left: 2vw

.icon-star
  width: 30.82px
  margin-right: 24px
  margin-left: 2vw

.icon-thinking
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-vr
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-clean
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-conjugation
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-sdgs
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-quiz
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.icon-map
  width: 39.82px
  margin-right: 20px
  margin-left: 2vw

.sub-img
  border: 0
  padding-left:140px
  height 35px

.showSubImg
  visibility hidden
  width 0
  height 0

</style>
